import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

/**
 * The root element for rendering the React application.
 * @type {ReactDOM.Root}
 */
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
